
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finds",
      function () {
        return require("private-next-pages/finds/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finds"])
      });
    }
  